// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3sjB-","additionalInfo":"AgreementModal_additionalInfo__l6Gma"};